import React from 'react';

import ReduxLeadsDialogHeader from './leadsmanage/LeadsDialogHeader';
import { Dialog, Select } from '@tencent/spaui';
import LeadsBaseInfoTab from './leadsmanage/LeadsBaseInfoTab';
import LeadsFollowRecordTab from './leadsmanage/LeadsFollowRecordTab';
import PropTypes from 'prop-types';
import { RPCFactory } from '../../utils/RequestUtil';
import { leadsSourceMap } from '../pages/setting/clue/leadsSourceMap';
import { store } from '../../store/Store';
import { LeadsManageAction } from '../../actions/LeadsManageAction';
import LeadsEditableFieldType from '../../consts/LeadsEditableFieldType';
import { Tags } from '../../consts/Tags';

import { isSubAccount } from '../../consts/multiAccountConfig';
const detailstyle = {
  width: '1091px',
};
export default class LeadsDetailComponent extends React.Component {
  /**
   *
   * @param props
   * props.leadsId
   */
  constructor(props) {
    super(props);
    this.state = {
      tab: 1,
      base: {},
      memo: {},
      action: {},
      showDistributeOwnerDialog: false,
      showDistributeOwnerDialogTarget: null,
      leadsOwners: [],
      searchDistributeOwnerValue: '',
      targetOwner: '',
      oneToOneTag: {},
      leadsScoreDialog: { show: false, disable: false },
      actionSubType: -1,
      leadsSubType: -1,
      tags: [],
    };
    RPCFactory.leadsManage.getLeadsContactAction(this.props.leadsId).done((data) => {
      if (data.leadsInfo) {
        this.setState({
          base: data.leadsInfo,
          memo: data.leadsInfo.memo,
          actionSubType: data.actionInfo.actionSubType,
          actionSubTypeName: data.actionInfo.actionSubTypeName,
          tags: data.tags,
          targetOwner: data.leadsInfo.ownerId,
        });
      }

      if (data.actionInfo) {
        this.setState({
          action: data.actionInfo,
        });
      }
    });
    RPCFactory.leadsManage.getLeadsOneToOneTagInfo(window.pageProps.uid, this.props.leadsId).done((data) => {
      this.setState({ oneToOneTag: data });
    });
  }

  onChangeTab = (event, key) => {
    this.setState({ tab: key });
  };

  hideDistributeOwnerDialog = (event) => {
    this.setState({ showDistributeOwnerDialog: false, showDistributeOwnerDialogTarget: null });
  };
  selectOwnerId(target) {
    if (this.props.isTestData) return;
    this.setState({
      showDistributeOwnerDialogTarget: target,
      showDistributeOwnerDialog: true,
    });
    this.getOwners();
  }
  getOwners() {
    RPCFactory.employeeManage.getEmployees(undefined, undefined, undefined, undefined, undefined, undefined)
      .done((data) => {
        const leadsOwner = [];
        (data.entities || []).forEach((employee) => {
          let active = true;
          if (employee.status !== 0) active = false;
          if (employee.leadsReceiveStatus === 0) active = false;
          leadsOwner.push({
            active,
            value: employee.userId,
            label: `${employee.name} - ${employee.userGroupName}`,
          });
        });
        this.setState({ leadsOwners: leadsOwner });
      });
  }
  distributeLeads = (event) => {
    RPCFactory.leadsManage
      .distributeLeads([this.props.leadsId], this.state.targetOwner)
      .done((data) => {
        const { base } = this.state;
        for (let i = 0; i < this.state.leadsOwners.length; i++) {
          if (this.state.leadsOwners[i].value == this.state.targetOwner) {
            base.ownerName = this.state.leadsOwners[i].label;
          }
        }
        // // 更新父列表字段
        store.dispatch({
          type: LeadsManageAction.UPDATE_SINGLE_LEADS,
          updateType: LeadsEditableFieldType.ownerName,
          targetValue: base.ownerName,
          targetLeadsId: this.props.leadsId,
        });

        this.setState({ base });
      })
      .fail((ret, msg) => {
        window.alert(msg);
      });
    this.hideDistributeOwnerDialog();
  };

  onChangeDistributeLeadsOwner = (event, value) => {
    this.setState({ targetOwner: value });
  };
  onSearchDistributeOwner = (event, value) => {
    this.setState({ searchDistributeOwnerValue: value });
  };
  leadsScoreDialog = {
    show: (target, value, leadsId) => {
      if (this.props.isTestData) return;
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.eventTarget = target;
      leadsScoreDialog.show = true;
      leadsScoreDialog.leadsId = this.props.leadsId;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onClose: () => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.show = false;
      this.setState({ leadsScoreDialog });
    },
    onChange: (event, value) => {
      const { leadsScoreDialog } = this.state;
      leadsScoreDialog.leadsIntentionScoreTag = value;
      this.setState({ leadsScoreDialog });
    },
    onConfirm: () => {
      const { leadsScoreDialog, oneToOneTag } = this.state;
      // 修改评分的时候需要将评分来源置为人工评分
      const oneToOneTagNew = { ...oneToOneTag };
      oneToOneTagNew.leadsIntentionScoreSource = 2;
      this.setState({ oneToOneTag: oneToOneTagNew });
      RPCFactory.leadsManage
        .updateLeadsIntentionTag(
          window.pageProps.uid,
          leadsScoreDialog.leadsId,
          leadsScoreDialog.leadsIntentionScoreTag,
        )
        .done((data) => {
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });

          const { oneToOneTag } = this.state;
          oneToOneTag.leadsIntentionScoreTag = leadsScoreDialog.leadsIntentionScoreTag;
          this.setState({ oneToOneTag });

          this.leadsScoreDialog.onClose();
          store.dispatch({
            type: LeadsManageAction.UPDATE_SINGLE_LEADS,
            updateType: LeadsEditableFieldType.INTENTION,
            targetValue: leadsScoreDialog.leadsIntentionScoreTag,
            targetLeadsId: leadsScoreDialog.leadsId,
          });
        })
        .fail((status, msg) => {
          alert(`请求失败，msg:${msg}`);
          leadsScoreDialog.disable = false;
          this.setState({ leadsScoreDialog });
        });
    },
  };
  render() {
    let leadsSourceName = '';
    if (this.state.base.leadsSource) {
      leadsSourceName = leadsSourceMap[this.state.base.leadsSource];
    }
    const leadSouceType = this.state.actionSubTypeName ? this.state.actionSubTypeName : '--';

    const canDistribute =
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_MANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CMANAGER' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_ADOPERATOR' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_DATA_ANALYST' ||
      window.pageProps.operatorRole == 'OPERATOR_ROLE_LEADS_CEMPLOYEE_MANAGER';
    console.log('99999',this.state.oneToOneTag)
    const leadsIntentionTagName = this.state.oneToOneTag?.leadsIntentionScoreTag
      ? Tags.leadsIntentionTag[this.state.oneToOneTag.leadsIntentionScoreTag]
      : '--';
    const leadsIntentionTagSource = this.state.oneToOneTag?.leadsIntentionScoreSource
      ? Tags.leadsIntentionSource[this.state.oneToOneTag.leadsIntentionScoreSource]
      : '';
    const leadsIntentionTags = [];
    Object.keys(Tags.leadsIntentionTag).forEach((key) => {
      leadsIntentionTags.push({ value: key, label: Tags.leadsIntentionTag[key] });
    });

    const actionTime = this.state.action.actionTime ? this.state.action.actionTime : '--';
    const leadsLastOperateTime = this.state.base.leadsLastOperateTime
      ? this.state.base.leadsLastOperateTime.substr(5)
      : '--';

    return (
      <div>
        <Dialog
          style={{ width: '300px' }}
          eventTarget={this.state.leadsScoreDialog.eventTarget}
          show={this.state.leadsScoreDialog.show}
          onClose={this.leadsScoreDialog.onClose}
          onSubmit={(e) => {
            const { leadsScoreDialog } = this.state;
            leadsScoreDialog.disable = true;
            this.setState({ leadsScoreDialog }, () => {
              this.leadsScoreDialog.onConfirm();
            });
          }}
          onCancel={this.leadsScoreDialog.onClose}
          title="修改线索评分"
          className="modal-mini modal-simple"
          disabled={this.state.leadsScoreDialog.disable}
        >
          <Select
            placeholder="线索评分"
            data={leadsIntentionTags}
            value={this.state.leadsScoreDialog.leadsIntentionScoreTag}
            onChange={this.leadsScoreDialog.onChange}
            onClear={this.leadsScoreDialog.onClear}
          />
        </Dialog>
        <Dialog
          show={this.state.showDistributeOwnerDialog}
          style={{ width: '300px' }}
          eventTarget={this.state.showDistributeOwnerDialogTarget}
          title="请选择线索归属人"
          className="modal-mini modal-simple leads-owner"
          onClose={this.hideDistributeOwnerDialog}
          onCancel={this.hideDistributeOwnerDialog}
          onSubmit={this.distributeLeads}
        >
          <Select
            search
            searchValue={this.state.searchDistributeOwnerValue}
            onSearch={this.onSearchDistributeOwner}
            data={this.state.leadsOwners}
            onChange={this.onChangeDistributeLeadsOwner}
            value={this.state.targetOwner}
          ></Select>
        </Dialog>
        <Dialog
          position="right"
          uncover={true}
          modalClassName="no-cover"
          className="with-full-height modal-lead-details"
          onClose={this.props.shutDown}
          onSubmit={this.props.shutDown}
          onCancel={this.props.shutDown}
          title="标题"
          hideFooter
          style={detailstyle}
        >
          <div className={`modal-lead-des-inner${this.props.isTestData ? ' is-test-data' : ''}`}>
            <div className="user-des">
              <ReduxLeadsDialogHeader
                oneToOneTag={this.state.oneToOneTag}
                showCallDialog={this.props.showCallDialog}
                leadsId={this.props.leadsId}
                name={this.props.name}
                location={this.props.location}
                isTestData={this.props.isTestData}
                tags={this.state.tags}
                leadsTab={this.props.leadsTab}
                ownerId={this.state.base.ownerId}
              />
              <div className="udes-card">
                {/* <UserTab/>*/}
                <LeadsBaseInfoTab leadsId={this.props.leadsId} />
              </div>
            </div>
            <div className="ser-des">
              <div className="ser-card">
                <ul className="ser-infolist">
                  <li>
                    <p className="tt">归属人</p>
                    <p className="desc">
                      {this.state.base.ownerName}
                      {canDistribute && !isSubAccount() && (
                        <i
                          onClick={(e) => {
                            this.selectOwnerId(e.target);
                          }}
                          className="icon icon-pen"
                        ></i>
                      )}
                    </p>
                  </li>
                  <li>
                    <p className="tt">线索评分</p>
                    <p className="desc">
                      {leadsIntentionTagName}
                      <i onClick={(e) => this.leadsScoreDialog.show(e.target)} className="icon icon-pen"></i>
                    </p>
                    <p className="source">{leadsIntentionTagSource}</p>
                  </li>
                  <li>
                    <p className="tt">线索来源</p>
                    <p className="desc">{leadsSourceName}</p>
                  </li>
                  <li>
                    <p className="tt">线索类型</p>
                    <p className="desc">{leadSouceType}</p>
                  </li>
                  <li>
                    <p className="tt">线索提交时间</p>
                    <p className="desc">{actionTime}</p>
                  </li>
                  {/* <li>*/}
                  {/* <p class="tt">线索更新时间</p>*/}
                  {/* <p class="desc">{leadsLastOperateTime}</p>*/}
                  {/* </li>*/}
                </ul>
              </div>
              <div className="ser-des">
                <LeadsFollowRecordTab
                  leadsId={this.props.leadsId}
                  actionSubType={this.state.actionSubType}
                  leadsSubType={this.state.leadsSubType}
                  leadsTab={this.props.leadsTab}
                  detailAdvertiserId={this.props.detailAdvertiserId}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

LeadsDetailComponent.propTypes = {
  leadsId: PropTypes.number.isRequired,
  shutDown: PropTypes.func.isRequired,
  showCallDialog: PropTypes.func.isRequired,
};
